export default function (app) {
	app.filter('leadingZero', function () {
		return function (input) {
			return ('' + input).length == 1 ? '0' + input : input;
		};
	});
};
